import {
  Arbeitszeit,
  ArbeitszeitenPausenart,
  Pause,
} from '../../../../../../../entities';
import { useArbeitszeitUpdate } from '../../../../../../../hooks';
import { handleOnCompleted } from '../../../../../handleOnCompleted';
import { useTranslation } from 'react-i18next';
import {
  ArbeitszeitenPauseneinstellung,
  ArbeitszeitenPausenInput,
} from '../../../../../../../../../gql/graphql';
import { mapPauseToInput } from '../../Forms/mapPauseToInputType';
import { useEffect, useState } from 'react';
import { Switch, TableCell } from '@e2n/ui';
import { toast } from '@/hooks/use-toast';
import * as Sentry from '@sentry/react';
import { useManagerCanEditArbeitszeiten } from '@/domain/arbeitszeiten/hooks/useManagerCanEditArbeitszeit';

export function BezahltCell({
  pause,
  arbeitszeit,
  isUpdating,
  setIsUpdating,
}: {
  pause: Pause;
  arbeitszeit: Arbeitszeit;
  isUpdating: boolean;
  setIsUpdating: (value: boolean) => void;
}) {
  const managerCanEditArbeitszeit = useManagerCanEditArbeitszeiten();

  const { id: pauseId, bezahlt, art } = pause;
  const [isBezahlt, setIsBezahlt] = useState(bezahlt);
  const [arbeitszeitUpdate] = useArbeitszeitUpdate();
  const currentPause = arbeitszeit.pausen.find((pause) => pause.id === pauseId);
  const { t } = useTranslation();

  useEffect(() => {
    setIsBezahlt(pause.bezahlt);
  }, [pause]);

  function handleOnCheckedChange(checked) {
    setIsBezahlt(checked);
    onChangeIsBezahlt(checked);
  }

  async function onChangeIsBezahlt(isBezahlt: boolean) {
    setIsUpdating(true);

    const newPause: ArbeitszeitenPausenInput = {
      ...mapPauseToInput(currentPause),
      bezahlt: isBezahlt,
    };

    const newPausen = arbeitszeit.pausen.map((pause) => {
      if (pause.id === pauseId) {
        return newPause;
      }
      return mapPauseToInput(pause);
    });

    arbeitszeitUpdate({
      arbeitszeitUpdateInput: {
        pausen: newPausen,
      },
      arbeitszeitId: arbeitszeit.id,
    })
      .then((result) => {
        handleOnCompleted(result.data, t);
        setIsUpdating(false);
      })
      .catch((e) => {
        setIsUpdating(false);
        toast({
          title: t(
            'domain.arbeitszeiten.sheet.header.arbeitszeitUpdateUnknownError',
          ),
        });
        Sentry.captureException(e);
      });
  }

  return (
    <TableCell className="font-medium">
      <Switch
        size="sm"
        id="pauseIsBezahlt"
        checked={isBezahlt}
        onCheckedChange={handleOnCheckedChange}
        disabled={
          isUpdating ||
          !managerCanEditArbeitszeit ||
          (arbeitszeit.pauseneinstellung ===
            ArbeitszeitenPauseneinstellung.Gesetzlich &&
            art === ArbeitszeitenPausenart.Gesetzlich)
        }
      />
    </TableCell>
  );
}
